import src from "IMAGE";
export default { src, width: 725, height: 160, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAR0lEQVR42hXDQQqAQAgAwP1VLLsQBiKEIHjs4CEo8CA9RPpzNjAtIp6zAMCKiNucs5flP8boLTPfuzDzrqpiZoe7XyLCRIQfnGwUjS2AwWEAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 2 }
